<script setup lang="ts">
const props = defineProps<{
  title: string;
  pageUrl: string;
}>();

const encodedPageUrl = computed(() => encodeURIComponent(props.pageUrl));
const encodedTitle = computed(() => encodeURIComponent(props.title));
</script>

<template>
  <header :class="[$style.section, $style.hero]">
    <div :class="$style.inner">
      <div :class="$style.heroLayout">
        <h1 :class="$style.title">{{ title }}</h1>

        <div :class="$style.share">
          <span :class="$style.shareLabel">Поделиться:</span>
          <a
            :href="`https://telegram.me/share/url?url=${encodedPageUrl}&text=${encodedTitle}`"
            target="_blank"
            rel="noopener noreferrer"
            :class="$style.socialLink"
            aria-label="Поделиться в Telegram"
          >
            <Icon name="my-icon:i-social-tg" :size="24" />
          </a>
          <a
            :href="`https://vk.com/share.php?url=${encodedPageUrl}&title=${encodedTitle}`"
            target="_blank"
            rel="noopener noreferrer"
            :class="$style.socialLink"
            aria-label="Поделиться ВКонтакте"
          >
            <Icon name="my-icon:i-social-vk" :size="24" />
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<style module lang="scss">
.section {
  display: flex;
  padding-left: 110px;
  padding-right: 110px;
}

.inner {
  width: 100%;
  max-width: 860px;
}

.hero {
  padding-top: 20px;
}

.heroLayout {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-4x);
}

.title {
  @include text_h1;
  max-width: 662px;
  margin: 0;
  color: var(--color-black-1);
}

.share {
  display: flex;
  align-items: center;
  gap: var(--space-1-5x);
  padding-top: 8px;
  flex-shrink: 0;
}

.shareLabel {
  @include text_caption1_caps;
  color: var(--color-black-2);
}

.socialLink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: var(--color-black-1);
  background-color: var(--color-gray-bg);
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: var(--color-red-1);
  }

  rect {
    fill: var(--color-gray-bg);
  }
}

@media (max-width: 1379px) {
  .section {
    padding-left: 20px;
    padding-right: 20px;
  }

  .inner {
    max-width: none;
  }

  .heroLayout {
    flex-direction: column-reverse;
    gap: 10px;
  }

  .title {
    @include text_h4;
  }

  .share {
    padding-top: 0;
  }
}

@media (max-width: 599px) {
  .title {
    @include text_h2_mobile;
  }
}

@media (max-width: 479px) {
  .shareLabel {
    font-size: 8px;
  }
}
</style>
